export default __webpack_public_path__ + "assets/images/city-icon-new-white-33618131.svg";